import { Beaker } from 'lucide-react';
import { useAuth } from '../../core/auth/AuthContext';

/**
 * Shows a persistent banner when the current account is in demo mode.
 * Demo accounts are read-only — all write operations are blocked by the backend.
 */
export function DemoModeBanner() {
  const { isDemo } = useAuth();

  if (!isDemo) return null;

  return (
    <div className="w-full bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium">
      <Beaker size={16} />
      <span>Mode démonstration — Les modifications ne sont pas enregistrées</span>
    </div>
  );
}
